<template>
  <div class="context-menu">
    <div class="context-menu__content">
      <slot />
    </div>

    <div
      v-click-outside="hide"
      class="context-menu__menu"
    >
      <button
        class="context-menu__toggle-button"
        @click.stop="toggleVisibility"
      >
        <svg viewBox="-192 0 512 512">
          <path d="m128 256c0 35.347656-28.652344 64-64 64s-64-28.652344-64-64 28.652344-64 64-64 64 28.652344 64 64zm0 0"/>
          <path d="m128 64c0 35.347656-28.652344 64-64 64s-64-28.652344-64-64 28.652344-64 64-64 64 28.652344 64 64zm0 0"/>
          <path d="m128 448c0 35.347656-28.652344 64-64 64s-64-28.652344-64-64 28.652344-64 64-64 64 28.652344 64 64zm0 0"/>
        </svg>
      </button>
      
      <div
        v-if="isMenuVisible"
        class="context-menu__menu-items"
        @click.stop="hide"
      >
        <slot name="menu" />
      </div>
    </div>
  </div>
</template>

<script>
  import ClickOutside from 'vue-click-outside'

  export default {
    data: () => ({
      isMenuVisible: false
    }),

    directives: {
      ClickOutside,
    },

    methods: {
      toggleVisibility () {
        this.isMenuVisible = !this.isMenuVisible
      },

      hide () {
        this.isMenuVisible = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .context-menu {
    position: relative;
    // display: inline-block;

    &__content {
      position: relative;
      z-index: 10;
    }

    &__menu {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      position: absolute;
      top: 10px;
      right: 10px;
      height: 10px;
      z-index: 11;
    }

    &__toggle-button {
      // padding: 5px 10px;
      border-radius: 5px;

      svg {
        fill: #fff;
        height: 20px;
      }
    }

    &:hover &__toggle-button,
    &__menu:hover &__toggle-button {
      // background-color: rgba(#000, .5);
    }

    &__menu-items {
      display: flex;
      min-width: 150px;
      flex-direction: column;
      margin-top: 10px;
      background-color: #fff;
      padding: 5px;
      border-radius: 5px;
      box-shadow: 0 12px 28px 0 rgba(#000, 0.2);

      .menu-item {
        width: 100%;
        text-align: left;
        padding: 5px 10px;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          fill: #050505;
          margin-right: auto;
          width: 16px;
          margin-right: 10px;
        }

        span {
          flex: 1;
          text-align: center;
          font-weight: 400;
          font-size: 15px;
          color: #050505;
        }

        &:hover {
          background-color: rgba(#000, .1);
          border-radius: 5px;
        }
      }
    }
  }
</style>